//默认视图
<template>
  <div id="default_view">
    <img :src="defaultImg" alt="下载中心">
  </div>
</template>

<script>
export default {
    name: 'default-view',
    data () {
      return {
        defaultImg: '/static/img/default_view.png'
      }
    },
    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/pages/publics/DefaultView.vue